// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain as preloadCheckoutShippingData } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/PreloadCheckoutShippingData";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { getDataLayer, rcBrand } from "@rc/XDL/Utilities/DataLayer";

export interface XngDeleteOrderParameterParameter {
    cart?: CartModel
    onSuccess?: (result: any) => void;
}

export const _GaCheckoutShippingFunnel: any = (props: any) => {
    const state = props.getState();
    if (state?.xGA?.checkoutFunnelEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const GA4Data = {
            event: "US001eComCheckout",
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 1
                    },
                }
            }
        } as any;

        dataLayer.push(GA4Data);
    }
};

addToEndOfChain(preloadCheckoutShippingData, _GaCheckoutShippingFunnel);
